import React from 'react';
import { Select } from '../../ui/Select';
import { DURATION_OPTIONS } from '../../../lib/constants';
import { OnboardingDraft } from './types';
interface StepTimingProps {
  data: Partial<OnboardingDraft>;
  updateData: (data: Partial<OnboardingDraft>) => void;
}
export function StepTiming({
  data,
  updateData
}: StepTimingProps) {
  // Generate next 12 months for move-in date
  const getMonths = () => {
    const months = [];
    const d = new Date();
    for (let i = 0; i < 12; i++) {
      const monthStr = d.toLocaleString('ro-RO', {
        month: 'long',
        year: 'numeric'
      });
      months.push({
        value: monthStr,
        label: monthStr.charAt(0).toUpperCase() + monthStr.slice(1)
      });
      d.setMonth(d.getMonth() + 1);
    }
    return months;
  };
  return <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1753">
      <div data-id="element-1754">
        <h2 className="text-2xl font-bold text-light-1" data-id="element-1755">
          Când vrei să te muți și pentru cât timp?
        </h2>
      </div>

      <div className="space-y-6" data-id="element-1756">
        <Select label="Data mutării" value={data.moveInDate || ''} onChange={e => updateData({
        moveInDate: e.target.value
      })} options={getMonths()} placeholder="Alege luna" className="bg-dark-2 border-dark-3" data-id="element-1757" />

        <Select label="Durata dorită" value={data.duration || ''} onChange={e => updateData({
        duration: e.target.value as any
      })} options={DURATION_OPTIONS} placeholder="Alege durata" className="bg-dark-2 border-dark-3" data-id="element-1758" />

        {data.duration === 'short' && <div className="animate-in slide-in-from-top-2 fade-in duration-300" data-id="element-1759">
            <Select label="Pentru câte luni?" value={data.shortMonths?.toString() || ''} onChange={e => updateData({
          shortMonths: parseInt(e.target.value)
        })} options={Array.from({
          length: 11
        }, (_, i) => ({
          value: (i + 1).toString(),
          label: `${i + 1} lun${i === 0 ? 'ă' : 'i'}`
        }))} placeholder="Selectează numărul de luni" className="bg-dark-2 border-dark-3" data-id="element-1760" />
          </div>}
      </div>
    </div>;
}